/* eslint-disable import/prefer-default-export */
import { USER_POSITIVE_FEEDBACK_GET_SUCCESS } from 'constants/index';

export function setPositiveFeedbackCount(payload) {
  return dispatch => {
    dispatch({ type: USER_POSITIVE_FEEDBACK_GET_SUCCESS, payload });
  };
}
